import "./Ubicacion.css";
import { items } from "./UbicacionItems.js";
import nupra from "../../assets/img/Ubicacion/nupra.webp";

export const Ubicacion = () => {
  return (
    <section id="ubicacion">
      <h3 className="ubicacion-title">Dónde encontrarnos</h3>
      <div className="ubicacion-bottom">
        <div className="ubicacion-bottom--left">
          <div className="ubicacion-bottom--left-logo">
            <img src={nupra} alt="Logo de Nupra Multiespacio" />
          </div>
          <div className="ubicacion-bottom--left-text">
            <h4>Nupra Multiespacio</h4>
            <div className="ubicacion-bottom--left-text-items">
              {items.map((item) => (
                <li
                  key={item.id}
                  className="ubicacion-bottom--left-text-items--item"
                >
                  <a href={item.href} target="_blank" rel="noreferrer">
                    <item.icon className="item-logo" />
                  </a>
                  <p>{item.label}</p>
                </li>
              ))}
            </div>
          </div>
        </div>
        <div className="ubicacion-bottom--right">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15717.98980711166!2d-68.8436409163613!3d-32.88688043234661!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x967e097f46ce22ed%3A0x7472a547d19116dc!2sNupra%20Multiespacio!5e0!3m2!1ses-419!2sar!4v1696097137126!5m2!1ses-419!2sar"
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="map"
            className="map"
          />
        </div>
      </div>
    </section>
  );
};
